import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Button } from 'react-bootstrap';
import boardLimit from '../../assets/images/board-limit.svg';

class NotFound extends Component {
  render() {
    return (
      <div className='downtime'>
        <div className='downtime_wrap'>
          <div className='downtime_content'>
            <h1>Something Went Wrong</h1>
            <p>We're experiencing technical difficulties at the moment please try again later!</p>
            <Button id="loginBtn" onClick={() => this.props.history.goBack()}>Let's Try That Again</Button>
          </div>
          
          <div className='downtime_icon'>
            <img alt="downtime icon" src={boardLimit}/>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(NotFound);